module.exports = __webpack_public_path__ + "static/about-2@2x-85345e142aba64cf66e2166412d4925d.jpg";